import React, { useEffect, useState } from 'react'
import Link from 'next/link'
import styled from 'styled-components/macro'
import useTranslation from 'next-translate/useTranslation'

import { PageLayout } from '@/components/Layout/PageLayout'
import { Path } from '@/components/Path'
import { Text } from '@/components/Text'

import { retrieve } from '@/utils/Helpers'
import { ColorsMap, FontWeightMap, device } from '@/utils/Theme'

import { StateInterface } from '@/types/State'

const Main = styled.div`
  display: flex;
  padding: 0 13%;
  @media (max-width: ${device.mobileS}) {
    padding: 0 2%;
  }
`

const MessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 20rem;
`

const Error404 = () => {
  const { t } = useTranslation('common')
  const [state, setState] = useState<StateInterface>({})

  useEffect(() => {
    const fetchSettings = async () => {
      const settings = await retrieve('api/settings').then((e) => e.json())
      setState({ settings: settings.data })
    }
    fetchSettings()
  }, [])

  return (
    <PageLayout title={state.settings ? `${t('title:not-found')} | ${state.settings.name}` : t('title:not-found')}>
      <Path pathLinks={[<span>{t('error', { code: 404 })}</span>]} />
      <Main>
        <MessageWrapper>
          <Text textColor={ColorsMap.primary} fontSize="xxxl" fontWeight={FontWeightMap.bold} mb="1rem">
            {t('error', { code: 404 })}
          </Text>
          <Text fontSize="l" mb="0.5rem">
            {t('error-message-404')}
          </Text>
          <Link href="/" passHref>
            <Text as="a" textColor={ColorsMap.primary} fontWeight={FontWeightMap.bold}>
              {t('go-back')}
            </Text>
          </Link>
        </MessageWrapper>
      </Main>
    </PageLayout>
  )
}

export default Error404

